export default __webpack_public_path__ + "static/media/Mongodb.0e729c65.png";